import React, { useEffect, useState } from "react";
import api from "../services/api";

export default function StudentReferralPortal() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [copied, setCopied] = useState(false);
  const load = () => api.get("referrals/me/").then(r => setData(r.data)).catch(e => setError(
    e?.response?.status === 401 ? "Connectez-vous pour accéder à votre parrainage." : "Impossible de charger le parrainage."
  ));
  // useEffect(load, []) passerait la Promise renvoyée par load() comme fonction
  // de nettoyage ; React l'appelle sans vérifier son type au démontage et plante
  // ("n is not a function"). Le wrapper garantit que l'effet retourne undefined.
  useEffect(() => { load(); }, []);
  const copy = async () => {
    await navigator.clipboard.writeText(data.code);
    setCopied(true);
  };
  return <main className="referral-page">
    <section className="referral-card">
      <a href="/" className="referral-back">← Retour à Quick Learning</a>
      <h1>Parrainage des élèves</h1>
      {error && <div className="alert alert-warning" role="alert">{error}</div>}
      {!data && !error && <div className="referral-loading" role="status" aria-live="polite">Chargement du parrainage…</div>}
      {data && <>
        {!data.campaign_enabled && <div className="alert alert-info">Le programme est en préparation. Votre code peut être partagé, mais aucun jour n’est attribué tant que les conditions commerciales ne sont pas activées.</div>}
        <p>Votre code personnel de parrainage</p>
        <div className="referral-code"><strong aria-label={`Code de parrainage ${data.code}`}>{data.code}</strong><button type="button" onClick={copy} aria-live="polite">{copied ? "Copié" : "Copier"}</button></div>
        <div className="referral-summary"><span>Jours attribués</span><strong>{data.total_days_awarded}</strong></div>
        <h2>Suivi</h2>
        {data.referrals.length === 0 ? <p>Aucun parrainage pour le moment.</p> : <ul className="referral-list">
          {data.referrals.map(item => <li key={item.id}><span>Parrainage #{item.id}</span><span>{item.status === "validated" ? "Validé" : item.status === "rejected" ? "Refusé" : "En attente"}</span><strong>{item.days_awarded} jour(s)</strong></li>)}
        </ul>}
        <p className="text-muted small">Les coordonnées, achats et paiements des filleuls ne sont jamais affichés.</p>
      </>}
    </section>
  </main>;
}
